import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CropVarianceReport } from './Pages/listing';

export const CropVarianceReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CropVarianceReport} />
    </Fragment>
)